export const SKILL_AREAS = [
  { key: 'prompting', label: 'Prompting' },
  { key: 'context', label: 'Context' },
  { key: 'research', label: 'Research' },
  { key: 'writing', label: 'Writing' },
  { key: 'reasoning', label: 'Reasoning' },
  { key: 'critique', label: 'Critique' },
  { key: 'verification', label: 'Verification' },
  { key: 'automation', label: 'Automation' },
  { key: 'creativity', label: 'Creativity' },
  { key: 'tool_use', label: 'Tool Use' },
] as const;

export type SkillAreaKey = (typeof SKILL_AREAS)[number]['key'];

export function getSkillLabel(key: string): string {
  return SKILL_AREAS.find((s) => s.key === key)?.label || key;
}

export function computeOverallScore(scores: Record<string, number>): number {
  const values = SKILL_AREAS.map((s) => scores[s.key] ?? 0);
  return Math.round(values.reduce((a, b) => a + b, 0) / values.length);
}
